// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3-qOP","title":"AfterBackImages_title__1wxOK","images":"AfterBackImages_images__1zP38"};